<template>
    <div class="modal modal--city modal_is-open modal-msg" v-if="showModal">
        <div class="modal__city">
            <button @click="closeModal" class="modal__close button-icon r-button" type="button">
                <span class="screen-reader" @click="closeModal()">Закрыть окно</span>
            </button>
            <h4 class="modal__title modal-msg__msg r-strong">Выберите город</h4>
            <div style="margin-bottom: 20px; margin-top: 20px;">
            <el-input v-model="search.title"
                      @input="searchCity()"
                      clearable
                      placeholder="Поиск по городам"/>
            </div>
            <div class="city__items">
                <div class="city__item text-clamped" v-show="!(index >= shortListCountCities && !showAll)" v-for="(city, index) in cities" v-html="city.title" @click="goToCity(city.full_url)">
                </div>
            </div>
            <div class="modal-msg__actions" v-show="showActions">
                <button class="modal-msg__action r-button button button_secondary" type="button" @click="showAll = true" v-if="!showAll">Показать еще</button>
                <button class="modal-msg__action r-button button button_secondary" type="button" @click="showAll = false" v-if="showAll">Свернуть</button>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../../admin/api/api";

    export default {
        name: "CitiesModal",
        data() {
            return {
                cities: [],
                showAll: false,
                searchCity: null,
                showModal: false,
                showActions: true,
                shortListCountCities: 20,
                search: {
                    title: ''
                }
            }
        },
        computed: {
            queryParams: {
                get() {
                    let params = [];

                    if (this.$cookie.getCookie('city-chosen')) {
                        params.push({
                            name: 'cityChosen',
                            value: true,
                        });
                    }

                    if (this.$cookie.getCookie('cookie-policy')) {
                        params.push({
                            name: 'cookiePolicy',
                            value: true,
                        });
                    }

                    return params;
                },
                cache: false,
            }
        },
        watch: {
            cities(value) {
                if (!value) {
                    return false;
                }

                this.showActions = value.length > this.shortListCountCities;
            }
        },
        created() {
            MenuEvent.$on('openCitiesModal', () => {
                this.showModal = true;
            });

            this.searchCity = _.debounce(() => {
                api.get('/city/search',{search: this.search})
                    .then((response) => {
                        this.cities = response.data;
                    })
            }, 500)
        },
        mounted() {
            api.get('/city/all')
                .then((response) => {
                    this.cities = response.data;
                })
        },
        updated() {
            MenuEvent.$emit('cityNotificationClose');
        },
        methods: {
            closeModal() {
                this.showModal = false;

                MenuEvent.$emit('closeCitiesModal');
            },
            goToCity(href) {
                let url = new URL(href);
                let searchParams = url.searchParams;

                this.queryParams.forEach((query) => {
                    searchParams.set(query.name, query.value);
                });

                url.search = searchParams.toString();

                return window.location.replace(url.toString());
            },
        }
    }
</script>
